import * as React from "react";
import { Stack, Typography } from "@mui/material";
import { Address } from "gen/clients";

interface Props {
  address?: Address;
}

const BusinessAddress: React.FC<Props> = ({ address }) => {
  const cityLine = [address?.city, address?.province?.name, address?.zipCode].filter(Boolean).join(", ");
  const hasAnyValue =
    address &&
    (address.address1 || address.address2 || cityLine || address.country?.name || address.phoneNumber || address.email);
  if (!hasAnyValue) {
    return <Typography>Not available</Typography>;
  }
  return (
    <Stack spacing={0.5}>
      {address?.address1 && <Typography>{address.address1}</Typography>}
      {address?.address2 && <Typography>{address.address2}</Typography>}
      {cityLine && <Typography>{cityLine}</Typography>}
      {address?.country?.name && <Typography>{address.country.name}</Typography>}
      {address?.phoneNumber && <Typography>{address.phoneNumber}</Typography>}
      {address?.email && <Typography>{address.email}</Typography>}
    </Stack>
  );
};

export { BusinessAddress };
